import { AppData, BookingData } from "../../AppDataProvider";

import { CompleteRecurringBookingStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils";

export type CompleteRecurringBookingStepOptions = {
  appData: AppData;
  payload?: CompleteRecurringBookingStepPayload;
};

type CompleteRecurringBookingStepBookingData = PartRequired<
  BookingData,
  "organisation" | "service"
>;

export const completeRecurringBookingStep = (
  options: CompleteRecurringBookingStepOptions,
): AppData => {
  Mixpanel.track({
    name: "Completed step",
    props: { step: "recurringBooking" },
  });

  const { bookingData } = options.appData;
  requireBookingDataFields<CompleteRecurringBookingStepBookingData>(
    bookingData,
    ["organisation", "service"],
  );
  const { organisation, service } = bookingData;
  const { allowBookingNotes, externalBookingQuestions } = organisation;

  const hasRelevantBookingQuestions = externalBookingQuestions.some(
    (question) =>
      !question.services ||
      question.services.map(({ _id }) => _id).includes(service._id),
  );

  const nextStep =
    allowBookingNotes || hasRelevantBookingQuestions
      ? "bookingQuestions"
      : "details";

  if (!options.payload) {
    return {
      ...options.appData,
      currentStep: nextStep,
    };
  }

  const { selectedBookings, reservedSpaceId, startDate } =
    options.payload.updatedData;

  const updatedBookingData = {
    ...bookingData,
    reservedSpaceId,
    selectedBookings,
    startDate,
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: nextStep,
  };
};
